import Vue from 'vue/dist/vue.js';
import axios from 'axios';
import VueRouter from 'vue-router';
import Tour from './components/Tour.vue'
import CustomerRoot from './components/CustomerRoot.vue'
import Accommodation from './components/Accommodation.vue'
import Passengers from './components/Passengers.vue'
import Extras from './components/Extras.vue'
import Confirmation from './components/Confirmation.vue'
import Failure from './components/Failure.vue'
import Pay from './components/Pay.vue'
import moment from 'moment'
import vSelect from 'vue-select'
import Breadcrumbs from 'vue-2-breadcrumbs'
import VueCookies from 'vue-cookies'
import Notifications from 'vue-notification'
import VueEasyLightbox from 'vue-easy-lightbox'
import VueSweetalert2 from 'vue-sweetalert2';

import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(Notifications)
Vue.component('v-select', vSelect)

Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(VueSweetalert2);

Vue.use(Breadcrumbs, {
  template:
    ' <nav class="breadcrumb" v-if="$breadcrumbs.length" aria-label="breadcrumb">\n' +
    '   <ol >\n' +
    '     <router-link tag="li" to="/" exact><a>Dashboard</a></router-link>\n' +
    '     <li v-for="(crumb, key) in $breadcrumbs" v-if="crumb.meta.breadcrumb" :key="key" aria-current="page">\n' +
    '       <router-link :to="{ path: crumb.path }">{{ getBreadcrumb(crumb.meta.breadcrumb) }}</router-link>' +
    '     </li>\n' +
    '   </ol>\n' +
    ' </nav>'
})

Vue.use(VueEasyLightbox)

// Filters
Vue.filter('formatDateTime', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateShort', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YY')
  }
})

Vue.filter('formatTimeShort', function(value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
})

Vue.filter('formatCurrency', function (value) {
  if (typeof value !== "number") {
      return value;
  }
  var formatter = new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0
  });
  return formatter.format(value);
});

Vue.prototype.$api = process.env.MIX_API_URL

const routes = [
  {
    path: '/',
    name: 'tour',
    component: Tour
  },
  {
    path: '/accommodation',
    name: 'accommodation',
    component: Accommodation
  },
  {
    path: '/extras',
    name: 'extras',
    component: Extras
  },
  {
    path: '/passengers',
    name: 'passengers',
    component: Passengers
  },
  {
    path: '/customer',
    name: 'customer',
    component: CustomerRoot
  },
  {
    path: '/pay',
    name: 'pay',
    component: Pay
  },
  {
    path: '/confirmation',
    name: 'confirmation',
    component: Confirmation
  },
  {
    path: '/failure',
    name: 'failure',
    component: Failure
  }
]

const router = new VueRouter({
  routes
})

new Vue({
  router,
  el: '#book',
  data: {
    loading: false,
    countries: null,
    tours: null,
    tour: null,
    departureDate: null,
    tourInstances: [],
    departureAirport: null,
    departureRegion: null,
    departurePoint: null,
    instance: null,
    price: null,
    booking: {
      customer: {},
      agent: {},
      tour_bookings: [],
      passengers: [],
      discount: null,
      extras: []
    },
    affiliate: null,
    bookingResponse: null,
    stripeLoaded: false,
    discount: {
      total_cost: 0,
      total_base_cost: 0,
      total_supplement_cost: 0,
      discount_value:0,
      discount_amount:0
    },
    accommodationNewDesign: false,
    defaultAgentComission:0,
    defaultAgentVat:0,
    loginDetails: JSON.parse(localStorage.getItem('logged_in_user_credentials')),
  },
  computed: {
    totalCost: function () {
      let percentageValue = 0;
      let totalCost = 0;
      let totalBaseCost = 0;
      let totalSupplementCost = 0;
      let extraCost = 0;
      

      for (let tour_booking of this.booking.tour_bookings) {
        totalCost += tour_booking.price * tour_booking.guests
        totalBaseCost += tour_booking.instance.base_price * tour_booking.guests
        totalSupplementCost+= (tour_booking.price - tour_booking.instance.base_price) * tour_booking.guests
      }
      
      this.discount.total_cost = totalCost
      
      // if(this.booking.discount) totalCost = totalCost - (this.booking.discount.value * this.booking.passengers.length);
      // console.log(this.booking.discount)
      if (this.booking.discount) {
        this.discount.discount_value = this.booking.discount.value

        if(this.booking.discount.per_person == 1) {
          if (this.booking.discount.penalty_type == 1) {
            // Percentage for multiple passengers - should it be the discount value * number of passengers?
            if (this.booking.discount.on_base_price == 0) {
              percentageValue = (totalCost / 100) * (this.booking.discount.value * this.booking.passengers.length);
            } else {
              percentageValue = (totalBaseCost / 100) * (this.booking.discount.value * this.booking.passengers.length);
            }

            this.discount.discount_amount = percentageValue
            
            totalCost = totalCost - percentageValue
            // this.booking.discount.value = percentageValue

          } else {
            totalCost = totalCost - (this.booking.discount.value * this.booking.passengers.length);
            this.discount.discount_amount = (this.booking.discount.value * this.booking.passengers.length)
          }
        } else {
          if(this.booking.discount.penalty_type == 1) {
            if (this.booking.discount.on_base_price == 0) {
              percentageValue = (totalCost / 100) * this.booking.discount.value
            } else {
              percentageValue = (totalBaseCost / 100) * this.booking.discount.value
            }
            totalCost = totalCost - percentageValue

            // this.booking.discount.value = percentageValue
            this.discount.discount_amount = percentageValue
          } else {
            totalCost = totalCost - this.booking.discount.value;
            this.discount.discount_amount = this.booking.discount.value
          }
        }
      }

      if(this.booking.extras)
      {
        for(let extras of this.booking.extras)
        {
          extraCost = extraCost + (extras.extra_price * extras.quantity)
        }
        totalCost = totalCost + extraCost
      }

      
      this.discount.total_base_cost = totalBaseCost
      this.discount.total_supplement_cost = totalSupplementCost
      return totalCost;
    },
    totalDeposit: function () {
      let totalDeposit = 0;
      if(this.instance.deposit_price) {
        totalDeposit = this.instance.deposit_price * this.passengerCount;
      } else if(this.instance.group.deposit_price) {
        totalDeposit = this.instance.group.deposit_price * this.passengerCount;
      } else {
        totalDeposit = this.instance.tour.deposit_price * this.passengerCount;
      }
      return totalDeposit;
    },
    passengerCount: function () {
      let count = 0;
        for (let tour_booking of this.booking.tour_bookings) {
          count += tour_booking.guests
        }
      return count;
    },
    extraCount: function()
    {
      let count = 0;
      if(this.booking.extras){
        for(let extra of this.booking.extras){
          count += 1
        }
      }
      return count;
    },
    extraCost: function()
    {
      let extraCost = 0;
      if(this.booking.extras){
        for(let extras of this.booking.extras)
        {
          extraCost = extraCost + (extras.extra_price * extras.quantity)
        }
      }
      return extraCost;

    },
    appliedDiscountedValue: function() {
      if (this.booking.discount) {
        
        if (this.booking.discount.penalty_type == 1) {
          return `${this.discount.discount_value}%`
        }else{
          return `£${this.discount.discount_value}`
        }
      }else{
        return null;
      }
    },
    agentComission(){
        return this.totalCost * (Number(this.defaultAgentComission) / 100)
    },
    agentBookingVat(){
        return this.agentComission * (Number(this.defaultAgentVat) / 100)
    },
  },
  created() {
    if (localStorage.getItem('customer')) {
      try {
        this.booking.customer = JSON.parse(localStorage.getItem('customer'));
      } catch(e) {
        localStorage.removeItem('customer');
      }
    }
    
    if($cookies.get('affiliate')) {
      this.loading = true;
      axios.get(this.$root.$api + 'affiliates/by_code/' + $cookies.get('affiliate'))
      .then(res => res.data)
      .then(response => {
        this.affiliate = response.data

        this.$root.loading = false
      })
    }

    if (this.loginDetails) {
      this.getLoggedInUserDetail()
    }
    
  },
  watch: {
    instance() {
      localStorage.setItem('instance', JSON.stringify(this.instance));
    },
    booking() {
      localStorage.setItem('booking', JSON.stringify(this.booking));
    }
  },
  methods: {
    getLoggedInUserDetail() {
        fetch(`${this.$root.$api}agent/user-detail`, {
          method: 'Post',
          body: JSON.stringify({
              user_type: this.loginDetails.login_type,
          }),
          headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + this.loginDetails.access_token
          }
      }).then(res => res.json())
      .then(response => {
          if (response.status) {
            this.booking.agent = response.data
            this.defaultAgentComission = response.master_settings.agent_commission
            this.defaultAgentVat = response.master_settings.agent_vat
          }
      })
    }
  }
});
